<input type="tel" [id]="elementId" name="candidateContactPhoneNumber" class="form-control access"
       [(ngModel)]="valueField" (change)="phoneNumberChanged()" required [disabled]="readOnly">